import DispatchConstants from '../constants/DispatchConstants';

import type { HelpCategoryProps, HelpTopicProps } from '../model/HelpTopics';

const updateSelectedHelpCategory =
  (selectedHelpCategory: HelpCategoryProps) =>
  (dispatch: (arg: { type: string; payload: HelpCategoryProps }) => void) =>
    dispatch({
      type: DispatchConstants.UPDATE_SELECTED_HELP_CATEGORY,
      payload: selectedHelpCategory,
    });

const updateSelectedHelpTopic =
  (selectedHelpTopic: HelpTopicProps) => (dispatch: (arg: { type: string; payload: HelpTopicProps }) => void) =>
    dispatch({
      type: DispatchConstants.UPDATE_SELECTED_HELP_TOPIC,
      payload: selectedHelpTopic,
    });

const SubmitRequestActions = { updateSelectedHelpCategory, updateSelectedHelpTopic };

export default SubmitRequestActions;
